(function () {
  'use strict';

  function initLuminaireFranceProductCard() {
    if (window.lfProductCardInitialized) return;

    window.lfProductCardInitialized = true;

    /*
     * Les fichiers JS sont chargés séparément par le thème.
     * Chaque module possède déjà son propre initialiseur.
     */

    if (window.lfWishlist && typeof window.lfWishlist.sync === 'function') {
      window.lfWishlist.sync();
    }

    if (window.lfNoel && typeof window.lfNoel.init === 'function') {
      window.lfNoel.init(document);
    }

    document.documentElement.classList.add(
      'lf-product-card-ready'
    );
  }


  /* =========================================
     CHARGEMENT INITIAL
  ========================================= */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initLuminaireFranceProductCard
    );
  } else {
    initLuminaireFranceProductCard();
  }


  /* =========================================
     SHOPIFY SECTION RELOAD
  ========================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (window.lfProductCard) {
        window.lfProductCard.init(
          event.target || document
        );
      }

      if (window.lfProductGallery) {
        window.lfProductGallery.init(
          event.target || document
        );
      }

      if (window.lfWishlist) {
        window.lfWishlist.sync();
      }

      if (window.lfNoel) {
        window.lfNoel.init(
          event.target || document
        );
      }
    }
  );


  /* =========================================
     SHOPIFY SECTION REORDER
  ========================================= */

  document.addEventListener(
    'shopify:section:reorder',
    function () {
      if (window.lfWishlist) {
        window.lfWishlist.sync();
      }
    }
  );

})();